import { useEffect, useMemo } from 'react'

import { MessageItem, SpamCheckEvent } from '@app/models'
import { fetchSpamChecksThunk } from '@app/store/spam'

import { useAppDispatch } from './useAppDispatch'
import { useSpam } from './useSpam'

export const useSpamChecks = (message: MessageItem) => {
  const dispatch = useAppDispatch()
  const state = useSpam()
  useEffect(() => {
    if (message.spamCheckIds?.length) {
      const missing = message.spamCheckIds.filter((id) => !state.spamChecks[id])
      if (missing.length) {
        dispatch(fetchSpamChecksThunk(missing))
      }
    }
  }, [message.id])
  const spamCheckIds = message.spamCheckIds
  return useMemo(() => {
    const spamChecks =
      spamCheckIds?.reduce((acc: SpamCheckEvent[], id: number) => {
        const check = state.spamChecks[id]
        if (!check) return acc
        acc.push(check)
        return acc
      }, []) || []

    return {
      spamChecks,
      loading: state.fetching,
    }
  }, [message.id, state.fetching])
}
